import { PhoneField, validatePhoneNumber } from '@boltenergy-be/design-system'
import { useFormContext } from 'react-hook-form'
import { PhoneProps } from 'components/inputs/phone/types'
import { useTranslation } from 'next-i18next'

const Phone = ({ grid }: PhoneProps) => {
  // React Hook Form
  const {
    clearErrors,
    formState: { errors },
    register,
    setValue,
    trigger,
    watch
  } = useFormContext()
  const watchPhone = watch('mobilePhone')

  // i18n
  const { t } = useTranslation(['commonFormFields', 'validation'])

  return (
    <PhoneField
      {...{ grid }}
      {...register('mobilePhone', {
        required: t('validation:required'),
        validate: (value: string) => validatePhoneNumber(value || '') || t('commonFormFields:phone.errors.invalid')
      })}
      label={t('commonFormFields:phone.label')}
      value={watchPhone}
      onBlur={() => trigger('mobilePhone')}
      onChange={(value) => {
        setValue('mobilePhone', value)
        clearErrors('mobilePhone')
      }}
      error={errors?.mobilePhone?.message as string}
    />
  )
}

export default Phone
